import { Injectable } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import {BehaviorSubject} from 'rxjs';

import { Agency, RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private _agencySlug: string = null;
  private _agencyChangeSource = new BehaviorSubject <string>(null);
  public actAsPatientId:number;

  public get agencySlug(): string {
    return this._agencySlug;
  }
  public get agency(): Promise<Agency> {
    return this._agencySlug
      ? this.rest.adminAgencyInfo(this._agencySlug)
      : Promise.resolve({} as Agency);
  }
  public agencyChanged$ = this._agencyChangeSource.asObservable();

  constructor(private router: Router, private rest: RestApiService) {
    router.events.subscribe(event => {
      if (event instanceof ResolveEnd) {
        let node = event.state.root; // start at the root
        // find the child node
        while (node.children.length) node = node.children[0];
        const slug = node.paramMap.get('agencySlug');
        if (slug !== this._agencySlug) {
          this._agencySlug = slug;
          this._agencyChangeSource.next(this._agencySlug);
        }
      }
    });
  }
}
